/**
 * Maximum number of banners that can be shown at one placement
 */
export const BLOOMREACH_MAX_BANNERS_PER_PLACEMENT = 5;
